'use strict';

/**
 * Handles input validation on input event for a given jQuery element
 * @param {jQuery} $ele - the jQuery element to validate
 */
function handleInputValidationOnInput($ele) {
    const actualValue = $ele.val().trim();
    const hasValue = actualValue.length > 0;

    // Toggle class based on input value
    $ele.toggleClass('has-value', hasValue);
    if (hasValue) {
        $ele.closest('.form-group').removeClass('error-class').find('.error-message').addClass('d-none');
    }
    if ($ele.hasClass('input-with-icons')) {
        $ele.siblings('.py-cross-right').toggleClass('show', hasValue);
        if ($ele.hasClass('search-field')) {
            $ele.siblings('.search-icon').toggleClass('d-none', hasValue);
        }
    }
}

$(document).ready(function ($) {
    // floating-input - set has-value class on page load, if data available.
    $('.py-floating-input').each(function () {
        handleInputValidationOnInput($(this));
    });

    // floating input has-value
    $(document).on('keyup', '.py-floating-input', function () {
        handleInputValidationOnInput($(this));
    });

    // event to handle clear icon
    $(document).on('click', '.py-cross-right', function () {
        const $this = $(this);
        $this.siblings('.py-floating-input').val('').removeClass('has-value').focus();
        $this.removeClass('show');
        $this.siblings('.search-icon').toggleClass('d-none');
    });
});
